"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
var __importStar =
  (this && this.__importStar) ||
  function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
  };
Object.defineProperty(exports, "__esModule", { value: true });
const BasicNode_1 = require("./BasicNode");
const types_1 = require("../types");
const short_hash_1 = __importDefault(require("short-hash"));
const uuid = __importStar(require("uuid"));
const schemaFaker_1 = require("../helper/schemaFaker");
class UserDefinedNode extends BasicNode_1.BasicNode {
  constructor(props) {
    if (!props) props = { type: types_1.NODE_TYPES.UserDefinedNode };
    if (props.type !== types_1.NODE_TYPES.UserDefinedNode)
      throw new Error("Invalid Node type");
    super(props);
  }
  getNodeLabel() {
    if (!this.nodeDefinition) {
      return super.getNodeLabel();
    }
    return this.nodeDefinition.display.label;
  }
  deserialize(data) {
    let nodeData = data || this.getNodeData();
    if (!nodeData && this.nodeDefinition)
      return JSON.parse(this.nodeDefinition.defaultParams);
    if (!nodeData) return {};
    return nodeData;
  }
  serialize(uiData) {
    return uiData;
  }
  validate() {
    // todo handle node data validation based on json schema
    return true;
  }
  setId(props) {
    this.setBasicNodeId(props);
  }
  setNodeDefinition(nodeDefinition) {
    this.nodeDefinition = nodeDefinition;
    const id = this.id;
    // if node has a id with  base node type, then update id based on the definition
    if (id.includes(this.getNodeType()) && nodeDefinition.display.id) {
      this.id =
        "node-" +
        short_hash_1.default(uuid.v4()) +
        "-" +
        nodeDefinition.display.id;
    }
  }
  getNodeDefinition() {
    return this.nodeDefinition;
  }
  getUserDefinedNodeId() {
    if (!this.nodeDefinition) return undefined;
    return this.nodeDefinition.id;
  }
  async getAvailableResources() {
    let availableResources = [];
    const nodeData = this.getNodeData();
    if (nodeData) {
      availableResources.push({
        nodeRef: this,
        selectedResourceId: this.id,
        path: "",
        label: this.getNodeName(),
        context: {
          outputPath: ""
        }
      });
    }
    return availableResources;
  }
  async getOutputKeys(params) {
    if (!this.nodeDefinition) return [];
    const { outputObjectExample } = this.nodeDefinition;
    try {
      const keys = await schemaFaker_1.getKeysOfObjectFromJSONSchema(
        JSON.parse(outputObjectExample)
      );
      return keys.map(k => ({ name: k, value: k }));
    } catch (e) {
      console.error(e);
      return super.getOutputKeys(params);
    }
  }
  async getSummary() {
    if (this.nodeDefinition) {
      return this.nodeDefinition.display.summaryTemplate;
    }
    return super.getSummary();
  }
}
exports.UserDefinedNode = UserDefinedNode;
//# sourceMappingURL=UserDefinedNode.js.map
